import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  alert: {
    '&&': {
      '& .MuiAlert-action': {
        paddingTop: 0,
      },
    },
  },
}))
